document.addEventListener('DOMContentLoaded', function () {

  // ── CSS injected immediately ─────────────────────────────────────────────
  // This runs before paint to prevent flash of poster/play-button
  const style = document.createElement('style');
  style.textContent = `
    /* Hide the poster play button once video is initialized */
    deferred-media[data-js-init] .deferred-media__poster {
      display: none !important;
    }

    /* Hide modal-opener play icon (desktop) */
    deferred-media[data-js-init] ~ modal-opener .product__media-icon,
    deferred-media[data-js-init] ~ modal-opener .product__media-toggle {
      display: none !important;
    }

    /* MOBILE: override Dawn's theme which hides deferred-media and shows modal-opener */
    @media screen and (max-width: 749px) {
      .product-media-container modal-opener {
        display: none !important;
      }
      .product-media-container deferred-media {
        display: block !important;
      }
    }
  `;
  document.head.appendChild(style);

  // ── Main video init ──────────────────────────────────────────────────────
  function initVideos() {
    document.querySelectorAll('deferred-media').forEach((media) => {
      if (media.dataset.jsInit) return;
      media.dataset.jsInit = 'true';

      // 1. Hide the poster button immediately
      const poster = media.querySelector('.deferred-media__poster');
      if (poster) poster.style.display = 'none';

      // 2. Get existing video or clone from template
      let video = media.querySelector('video');
      if (!video) {
        const tmpl = media.querySelector('template');
        if (!tmpl) return;
        media.appendChild(tmpl.content.cloneNode(true));
        video = media.querySelector('video');
      }
      if (!video) return;

      // 3. Remove any duplicate videos (template clone + already-rendered)
      const allVideos = media.querySelectorAll('video');
      allVideos.forEach((v, i) => { if (i > 0) v.remove(); });

      // 4. Apply all required attributes for iOS/Android silent autoplay
      video.muted        = true;
      video.defaultMuted = true;
      video.autoplay     = true;
      video.loop         = true;
      video.playsInline  = true;
      video.preload      = 'auto';
      video.controls     = false;

      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');

      video.load();

      // 5. Play when visible in viewport
      playWhenVisible(video, media);
    });
  }

  function playWhenVisible(video, media) {
    const tryPlay = () => {
      const promise = video.play();
      if (promise !== undefined) {
        promise
          .then(() => {
            // Successfully autoplaying — hide poster again just in case
            const poster = media.querySelector('.deferred-media__poster');
            if (poster) poster.style.display = 'none';
          })
          .catch(() => {
            // Autoplay blocked — on iOS we need a real user gesture
            // Show poster so user knows to tap, then play inline (no lightbox)
            const poster = media.querySelector('.deferred-media__poster');
            if (poster) {
              poster.style.display = '';
              poster.addEventListener('click', function onTap(e) {
                e.preventDefault();
                e.stopPropagation();
                video.play().then(() => {
                  poster.style.display = 'none';
                }).catch(() => {});
                poster.removeEventListener('click', onTap);
              });
            }
          });
      }
    };

    if (!('IntersectionObserver' in window)) {
      setTimeout(tryPlay, 300);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          tryPlay();
          observer.unobserve(media);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(media);
  }

  initVideos();
  document.addEventListener('shopify:section:load', initVideos);
});

<!-- Swiper JS CDN -->
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.image-slider-wrapper', {
      direction: 'horizontal', // or 'horizontal' if needed
      loop: true,
      slidesPerView: 3.5, // 👈 Show 3 slides at once
    spaceBetween: 20, // Optional: space between slides in px
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
       pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
      // For mobile devices (less than 768px), show 1 slide
      0: {
        slidesPerView: 1,
        direction: 'horizontal',
      },
      // For tablets (768px and up), show 2 slides
      768: {
        slidesPerView: 2,
      
      },
      // For desktops (1024px and up), show 3 slides
      1024: {
        slidesPerView: 3,
      }
    }
    });
  });

 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.testimonials-swiper', {
      direction: 'horizontal',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction'
      },
      autoplay: {
        delay: 6000,
      },
    });
  });

 document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[name="variants"]')) return;

    let imgPath = e.target.dataset.image;
    console.log('imgPath', imgPath);

    if (!imgPath) return;

    let fullImgUrl = imgPath.startsWith('http')
      ? imgPath
      : 'https://1z5s0m-ta.myshopify.com/cdn/shop/' + imgPath;

    console.log('fullImgUrl', fullImgUrl);

    document.querySelectorAll('.product__media.media img').forEach(function (img) {
      img.src = fullImgUrl;
      img.srcset = fullImgUrl;
    });

    document.querySelectorAll('.product-media-modal__content .global-media-settings').forEach(function (img) {
      img.src = fullImgUrl;
      img.srcset = fullImgUrl;
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('multi-popup-luminary-blueprint');
  const popupProducts = document.getElementById('popup-products');
  const closeBtn = document.getElementById('popup-close');

  /* ---------------- QUANTITY HANDLING ---------------- */

  document.querySelectorAll('.variant-qty').forEach(qtyInput => {
    qtyInput.addEventListener('input', function () {
      let val = parseInt(this.value) || 1;
      if (val < 1) val = 1;
      this.value = val;

      const checkboxId = this.dataset.target;
      const checkbox = document.getElementById(checkboxId);
      if (checkbox) checkbox.dataset.quantity = val;
    });
  });

  
  document.querySelectorAll('.quantity').forEach(quantityWrapper => {
    const qtyInput = quantityWrapper.querySelector('.variant-qty');
    const plusBtn = quantityWrapper.querySelector('button[name="plus"]');
    const minusBtn = quantityWrapper.querySelector('button[name="minus"]');

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val;
        qtyInput.dispatchEvent(new Event('input')); // Sync with checkbox
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val < 1) val = 1;
        qtyInput.value = val;
        qtyInput.dispatchEvent(new Event('input')); // Sync with checkbox
      });
    }
  });


  /* ---------------- OPEN POPUP ---------------- */
  let autocompleteMain = null;
  document
    .getElementById('add-multiple-to-cart-luminary-blueprint')
    .addEventListener('click', function () {

      if (!autocompleteMain) {
        autocompleteMain = initGooglePlaces({
          addressId: 'user-address',
          hiddenAddressId: 'address',
          latId: 'lat',
          lngId: 'lng',
          // offsetId: 'utcoffset'
        });
      }

      selectedVariants = Array.from(
        document.querySelectorAll('input[name="variants"]:checked')
      )
        .filter(el => el.closest('.luminary-blueprint'))
        .map(el => ({
          id: parseInt(el.value),
          title: el.dataset.attr,
          quantity: parseInt(el.dataset.quantity || 1)
        }));

      if (!selectedVariants.length) {
        alert('Please select at least one edition.');
        return;
      }

      popupProducts.innerHTML = selectedVariants
        .map(v => `<p>${v.title} - Qty: ${v.quantity}</p>`)
        .join('');

      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });

  /* ---------------- CLOSE POPUP ---------------- */

  closeBtn.addEventListener('click', () => {
    popup.style.display = 'none';
    document.body.style.overflow = '';
  });

  popup.addEventListener('click', e => {
    if (e.target === popup) {
      popup.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  /* ---------------- SUBMIT CART ---------------- */

document.getElementById("popup-submit").addEventListener("click", function () {
  const address = document.getElementById("user-address").value.trim();
  const deliveryDateTime = document.getElementById("datetime").value.trim();
  const lat = document.getElementById("lat")?.value || "";
  const lng = document.getElementById("lng")?.value || "";
  // const offsetValue = document.getElementById("utcoffset")?.value || "";
  const selectedLanguage = document.getElementById("languages").value;
   console.log('Add to Cart — Latitude:', lat, 'Longitude:', lng);
  if (!address || !deliveryDateTime || !lat || !lng) {
    alert("Please select the Birthplace from Google suggestions and fill date/time.");
    return;
  }

  const itemsWithProps = selectedVariants.map(v => ({
    id: v.id,
    quantity: v.quantity,
    properties: {
    [window.themeStrings.birthdateProperty]: deliveryDateTime,
    [window.themeStrings.birthplaceProperty]: address,
    _Latitude: lat,
    _Longitude: lng,
    [window.themeStrings.bookLanguageProperty]: selectedLanguage
  }
  }));

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: itemsWithProps })
  })
    .then(async res => {
      const data = await res.json();
      if (!res.ok) {
        console.error("Cart add failed:", data);
        alert(data.description || data.message || "One or more selected items couldn't be added — please check availability and try again.");
        return; // ← stop, do NOT redirect on failure
      }
      window.location.href = "/cart";
    })
    .catch(err => {
      console.error(err);
      alert("Something went wrong adding to cart. Please try again.");
    });
});

  /* ---------------- UTC OFFSET ---------------- */
  // function getUTCOffset() {
  //   const offset = -new Date().getTimezoneOffset();
  //   const sign = offset >= 0 ? "+" : "-";
  //   const hours = String(Math.floor(Math.abs(offset)/60)).padStart(2,"0");
  //   const minutes = String(Math.abs(offset)%60).padStart(2,"0");
  //   return `${sign}${hours}:${minutes}`;
  // }

  // document.getElementById("utcoffset").value = getUTCOffset();

  /* ---------------- GOOGLE PLACES + TIMEZONE ---------------- */
  function initGooglePlaces({ addressId, hiddenAddressId, latId, lngId, offsetId }) {
    if (!window.google) return;
    const addressInput = document.getElementById(addressId);
    const hiddenAddress = document.getElementById(hiddenAddressId);
    const latInput = document.getElementById(latId);
    const lngInput = document.getElementById(lngId);
    // const offsetInput = document.getElementById(offsetId);
    if (!addressInput) return;

    const autocomplete = new google.maps.places.Autocomplete(addressInput, { types: ['geocode'] });

    autocomplete.addListener('place_changed', async () => {
      const place = autocomplete.getPlace();
      if (!place?.geometry) return;

      hiddenAddress.value = place.formatted_address || '';
      latInput.value = place.geometry.location.lat();
      lngInput.value = place.geometry.location.lng();
      console.log('Google Places selected — lat:', latInput.value, 'lng:', lngInput.value);
      const timestamp = Math.floor(Date.now() / 1000);
      const apiKey = "AIzaSyAckoo_sSHgFB4Q3wN_W1FgUhu0xKdxNac"; // ✅ correct key
      const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latInput.value},${lngInput.value}&timestamp=${timestamp}&key=${apiKey}`;

      try {
        const res = await fetch(url);
        const data = await res.json();
        if(data.status === 'OK') {
          const totalOffset = (data.rawOffset + data.dstOffset)/60;
          const sign = totalOffset >= 0 ? '+' : '-';
          const h = String(Math.floor(Math.abs(totalOffset)/60)).padStart(2,'0');
          const m = String(Math.abs(totalOffset)%60).padStart(2,'0');
          // offsetInput.value = `${sign}${h}:${m}`;
          // console.log(`${offsetId} updated to`, offsetInput.value);
        }
      } catch(e) { console.error(e); }
    });

    addressInput.addEventListener('input', () => { hiddenAddress.value = addressInput.value; });
  }

  function loadGooglePlaces() {
    if(window.google) return;
    const script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAckoo_sSHgFB4Q3wN_W1FgUhu0xKdxNac&libraries=places";
    script.async = true; script.defer = true;
    document.body.appendChild(script);
  }

  loadGooglePlaces();
});

document.addEventListener("DOMContentLoaded", function(){

  const coverSelect = document.getElementById("cover-type");
  const variantRows = document.querySelectorAll(".variant-row");

  function filterVariants(){

    let selectedCover = coverSelect.value;

    variantRows.forEach(row => {

      let checkbox = row.querySelector("input");
      let cover = checkbox.dataset.cover;

      if(cover === selectedCover){
        row.style.display = "flex";
      } else {
        row.style.display = "none";
        checkbox.checked = false;
      }

    });

  }

  coverSelect.addEventListener("change", filterVariants);

  filterVariants();

});